import { useQuery } from '@tanstack/react-query'
import React from 'react'
import { getDailyReportData } from 'services/apiReport'

const useGetDailyReport = (params) => {
  const{isPending, isSuccess, isError, error, data,refetch} = useQuery({
    queryKey:['dailyReportData',params],
    queryFn:({queryKey})=> getDailyReportData(queryKey[1]),
    enabled: !!params,
    keepPreviousData:true,
    staleTime: 2 * 60 * 60 * 1000,
  })

  return{isPending, isSuccess, isError, error, data,refetch}
}

export default useGetDailyReport